import type { PackageSettingsMatch } from '@ms-cloudpack/common-types';

/**
 * Validate a package settings match object.
 * (As of writing, this just checks that negated matches don't have a version.)
 * @returns object with validation info (so the caller can log and/or throw as needed)
 */
export function validateMatch(match: PackageSettingsMatch): { isValid: false; error: string } | { isValid: true } {
  if (typeof match === 'object' && match.name.startsWith('!') && match.version && match.version !== '*') {
    return {
      isValid: false,
      error: `Negated match name "${match.name}" cannot have a version ("${match.version}")`,
    };
  }
  return { isValid: true };
}
